import React, { useState, createContext, useContext, useEffect } from 'react';
import { getFirestore, collection, getDocs, doc, setDoc} from 'firebase/firestore';


const DBContext = createContext([])

export const useDBContext = () => useContext(DBContext)


const DBContextProvider = ({ children }) => {

    const db = getFirestore()
    const [articles, setArticles] = useState([])
    const [authors, setAuthors] = useState([])
    const [categories, setCategories] = useState([])
    const [drafts, setDrafts] = useState([])
    const [banners, setBanners] = useState([])

    const getBanners = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, 'banners'));
            const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            return setBanners(data);
        } catch (error) {
            throw error;
        }
      };
    const getArticles = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, 'articles'));
            const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            return setArticles(data);
        } catch (error) {
            throw error;
        }
      };

      const getAuthors = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, 'authors'));
            const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            return setAuthors(data);
        } catch (error) {
            throw error;
        }
      };
  

      const getCategories = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, 'categories'));
            const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            return setCategories(data);
        } catch (error) {
            throw error;
        }
      };

      const getDrafts = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, 'drafts'));
            const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            return setDrafts(data);
        } catch (error) {
            throw error;
        }
      };
  
  
  

    return (
        <DBContext.Provider value={{
            getArticles,
            getAuthors,
            getCategories,
            getDrafts,
            getBanners,
            articles,
            drafts,
            categories,
            authors,
            banners
            
        }}>
            {children}

        </DBContext.Provider>
    )

}

export default DBContextProvider